var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragHandle = function SvgDragHandle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16,
    viewBox: "0 0 8 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E2E2E2",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h2v2H1zM1 5h2v2H1zM5 1h2v2H5zM5 5h2v2H5zM1 9h2v2H1zM5 9h2v2H5zM1 13h2v2H1zM5 13h2v2H5z"
  }))));
};
export default SvgDragHandle;